import React, { useState } from "react";
import { connect } from "react-redux";

import language from "../../../language";
import { Button } from "../../Button";
import CheckboxQuestionnaire from "../../Input/CheckboxQuestionnaire";

/**
 * Which kind of request is being raised, asked before anything else.
 *
 * It used to be a row part-way down the form, which meant a doctor raising an
 * emergency release answered the patient-consent question first - a question
 * that does not apply, because on an emergency release the doctor takes the
 * accountability rather than the patient giving consent. Asking first lets
 * each kind open the form it actually needs.
 *
 * Same single-select control the Request Type question used before it moved
 * here, so picking a kind looks the way it always did.
 */
const TYPES = [
  { value: "isOrdinary", titleKey: "ordinary" },
  { value: "isBooking", titleKey: "booking" },
  { value: "isEmergencyRelease", titleKey: "emergency_release" },
];

const RequestTypeChooser = ({ defaultLanguage, onChoose, onCancel }) => {
  const [requestType, setRequestType] = useState(null);

  return (
    <div>
      <div className="card-body">
        <CheckboxQuestionnaire
          questionText={language[defaultLanguage].choose_request_type_help}
          answers={TYPES.map((el) => ({
            field: "requestType",
            label: language[defaultLanguage][el.titleKey],
            value: el.value,
            onPress: () => setRequestType(el.value),
          }))}
          checked={requestType}
        />
      </div>
      <div className="modal-footer">
        <Button
          text={language[defaultLanguage].cancel}
          className="btn-default"
          onPress={onCancel}
        />
        <Button
          text={language[defaultLanguage].continue}
          onPress={() => onChoose(requestType)}
          disabled={!requestType}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;

  return { defaultLanguage };
};

export default connect(mapStateToProps)(RequestTypeChooser);
